import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useUser from '@alltrails/context/hooks/useUser';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import Button from '@alltrails/denali/components/Button';
import Heading from '@alltrails/denali/components/Heading';
import PeakFeatureListTable from '@alltrails/upsell/components/UpsellSystem/PeakFeatureList/PeakFeatureListTable';
import hikersOnBridgeSrc from './hikers-on-bridge-image.avif';
import styles from './ProComparison.module.scss';

const SignUpModal = dynamic(() => import('@alltrails/user-auth/components/SignUpModal'), { ssr: false });

export default function ProComparison() {
  const intl = useIntl();
  const user = useUser();
  const languageRegionCode = useLanguageRegionCode();
  const [isSignUpModalOpen, setIsSignUpModalOpen] = useState(false);

  const params = new URLSearchParams(useSearchParams());
  const search = params.toString();
  const checkoutUrl = wrapUrlSafe(`/plans/checkout${search.length > 0 ? `?${search}` : ''}`, languageRegionCode);

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <Image
          src={hikersOnBridgeSrc}
          alt={intl.formatMessage({ defaultMessage: 'Friends hiking across a bridge near a lake.' })}
          className={styles.image}
        />
      </div>
      <div className={styles.descriptionContainer}>
        <Heading as="h2" className={styles.header} size="500">
          <FormattedMessage defaultMessage="Explore confidently with AllTrails Plus" />
        </Heading>
        <PeakFeatureListTable className={styles.comparisonTable} disableMidpointTracking hidePeak tierSelected="plus" />
        <div className={styles.buttonContainer}>
          <Button
            text={<FormattedMessage defaultMessage="Start your free trial" />}
            {...(user ? { linkInfo: { href: checkoutUrl } } : { onClick: () => setIsSignUpModalOpen(true) })}
            variant="primary"
          />
        </div>
        {isSignUpModalOpen && (
          <SignUpModal
            isOpen
            closeModal={() => setIsSignUpModalOpen(false)}
            onSuccess={() => {
              setIsSignUpModalOpen(false);
              window.location.assign(checkoutUrl);
            }}
            trigger="Upgrade"
            upsellTrigger="Upgrade"
            hideUpsell
          />
        )}
      </div>
    </div>
  );
}
